import { createI18n } from 'vue-i18n'
import ar from './locales/ar.json'
import en from './locales/en.json'

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'ar', // default locale
  fallbackLocale: 'ar',
  messages: {
    ar,
    en
  },
  missing: (locale, key) => {
    console.warn(`Missing translation: ${key} for locale: ${locale}`)
    return key
  },
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  pluralizationRules: {
    // eslint-disable-next-line no-unused-vars
    ar: function(choice, choicesLength) {
      // Arabic has six forms:
      // zero, one, two, few (3-10), many (11-99), plural (100+)
      if (choice === 0) return 0
      if (choice === 1) return 1
      if (choice === 2) return 2
      if (choice >= 3 && choice <= 10) return 3
      if (choice >= 11 && choice <= 99) return 4
      return 5
    }
  }
}) 